import { Progress } from '@coconut-software/ui';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles, useTheme } from 'react-jss';
import { USER_PREFERENCE } from '../constants';
import { LocaleContext } from '../contexts/LocaleContext';
import { SelectionContext } from '../contexts/SelectionContext';
import { useQrCode } from '../hooks/useQrCode';

const useStyles = createUseStyles(() => ({
  qrCode: {
    aspectRatio: '1 / 1',
    height: '100%',
  },
  fadeIn: {
    animation: '$zoomFadeIn 0.25s ease-out forwards',
    opacity: 0,
  },
  '@keyframes zoomFadeIn': {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
}));

export const KioskQrCode = () => {
  const intl = useIntl();
  const classes = useStyles({ theme: useTheme() });
  const [{ user, bookingWalkIn, location, service, userPreference }] =
    useContext(SelectionContext);
  const [locale] = useContext(LocaleContext);

  const shouldSetPreferredLang =
    !user?.id &&
    userPreference?.id &&
    userPreference?.id !== USER_PREFERENCE.SPECIFIC &&
    userPreference?.id !== USER_PREFERENCE.RANDOM;

  const { data: qr, isFetching } = useQrCode({
    locationId: location?.id && `${location.id}`,
    language: locale,
    preferredLang: shouldSetPreferredLang ? userPreference.id : undefined,
    preferredStaffId: user?.id && `${user.id}`,
    serviceId: service?.id && `${service.id}`,
    walkIn: bookingWalkIn,
  });

  return (
    <div
      className={clsx(
        classes.qrCode,
        'bg-white-100 rounded-lg flex items-center justify-center',
      )}
    >
      {qr && !isFetching ? (
        <img
          alt={intl.formatMessage({ id: 'Landing.kiosk.qr_code.alt' })}
          className={clsx(
            classes.fadeIn,
            'relative bg-white-100 rounded-lg h-full w-full',
          )}
          src={typeof qr.data === 'string' ? qr.data : ''}
        />
      ) : (
        <Progress size="large" variant="circular" />
      )}
    </div>
  );
};
